import * as React from "react";

import { __debug, onLanguageChange, onTranslationChange } from "@opendash/i18n";
import { Input, Table, Typography } from "antd";

import { AdminLayout, useForceRender } from "..";

export const DebugTranslationsRoute = React.memo(
  function DebugTranslationsRoute() {
    const state = __debug();
    const [filterStringInput, setFilterStringInput] = React.useState("");
    const [filterString, setFilterString] = React.useState("");
    const forceRender = useForceRender();

    React.useEffect(() => {
      return onTranslationChange((namespace) => {
        forceRender();
      });
    }, []);

    React.useEffect(() => {
      return onLanguageChange((lang) => {
        forceRender();
      });
    }, []);

    const dataSource = React.useMemo(() => {
      if (!filterString || filterString.length < 3) return [];
      return Object.entries(state.translations)
        .flatMap(([language, namespaceMap]) => {
          return Object.entries(namespaceMap).flatMap(
            ([namespace, translationMap]) => {
              return Object.entries(translationMap).map(
                ([translationKey, translation]) => {
                  const test = filterString.toLowerCase();
                  if (
                    namespace.toLowerCase().indexOf(test) === -1 &&
                    translationKey.toLowerCase().indexOf(test) === -1 &&
                    translation.toLowerCase().indexOf(test) === -1
                  ) {
                    console.log("SKIP", namespace, translationKey, translation);
                    return null;
                  }
                  return {
                    language,
                    namespace,
                    translationKey,
                    translation,
                  };
                }
              );
            }
          );
        })
        .filter((x) => !!x);
    }, [filterString]);

    return (
      <AdminLayout>
        {/* <pre>
          {JSON.stringify(
            {
              language: state.language,
              languages: state.languages,
            },
            null,
            2
          )}
        </pre> */}
        <Input.Search
          value={filterStringInput}
          onChange={(e) => {
            setFilterStringInput(e.target.value);
          }}
          onSearch={setFilterString}
        />
        {filterString && filterString.length > 2 && (
          <Table
            size="middle"
            pagination={false}
            dataSource={dataSource}
            columns={[
              // {
              //   title: "language",
              //   dataIndex: "language",
              //   key: "language",
              // },
              // {
              //   title: "namespace",
              //   dataIndex: "namespace",
              //   key: "namespace",
              // },
              {
                title: "translationKey",
                dataIndex: "translationKey",
                key: "translationKey",
                render: (value, row) => {
                  const key = `${row.namespace}:${row.translationKey}`;
                  const code = `t("${key}")`;

                  return (
                    <Typography.Paragraph
                      copyable={{ text: code }}
                      children={key}
                      style={{ margin: 0 }}
                    />
                  );
                },
              },
              {
                title: "translation",
                dataIndex: "translation",
                key: "translation",
              },
            ]}
          />
        )}
      </AdminLayout>
    );
  }
);
